import { themeColor } from "./_helpers";

export const avatarTokens = {
  border: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.neutral.200}",
  }),
};
